import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import {
  Modal,
  Button,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Glyphicon
} from 'react-bootstrap';
import './SaveAsModal.css';

const SaveAsModal = ({ name, onClose, onSave, isOpen }) => {
  const [reportName, setReportName] = useState(name);

  const handleChangeName = e => setReportName(e.target.value);

  const handleSave = async () => {
    await onSave(reportName);
    await onClose();
  };

  useEffect(() => {
    setReportName(name);
  }, [name]);

  return (
    <Modal
      className="tvt-report-builder__modal"
      show={isOpen}
      onHide={onClose}
      backdrop
    >
      <Modal.Header>
        <Modal.Title>Save As</Modal.Title>
        <Glyphicon
          className="tvt-report-builder__modal-close-btn"
          onClick={onClose}
          glyph="remove"
        />
      </Modal.Header>

      <Modal.Body>
        You can save this custom report for future use. You will be able to
        view, edit and share the report from <b>My Reports</b> screen.
        <Form>
          <FormGroup
            controlId="tvt-report-builder__modal-save-as-form"
            className="tvt-report-builder__modal-save-as-form"
          >
            <ControlLabel>Report Name</ControlLabel>
            <FormControl
              type="text"
              label="Text"
              placeholder="Add a name to the report"
              value={reportName}
              onChange={handleChangeName}
            />
          </FormGroup>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={handleSave} disabled={isEmpty(reportName)}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

SaveAsModal.propTypes = {
  name: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

SaveAsModal.defaultProps = {
  name: ''
};

export default SaveAsModal;
